<div class="background-refresh-indicator"
     [class.background-refresh-indicator--active]="active()"
     data-testid="background-refresh-indicator"
     role="status"
     aria-live="polite"
     [attr.aria-hidden]="active() ? null : true"
     aria-label="Refreshing data in the background">
  <div class="background-refresh-indicator-bar"></div>
</div>